<template>
  <div class="animated fadeIn">
    <div v-if="dashdata && dashdata.KPI" class="row">
      <div class="col-xl" >
        <div class="card">
          <div class="card-body">

            <div class="card2 cardsection">
              <div class="card-body">
                <div class="wrap-am wrapper">
                  <div class="txt-rot-am">{{ $t('Webportal.DashboardBMW.AllModels') }}</div>
                  <div class="content">
                    <div class="am-one">
                      <div class="kpihead kpispec text-upper" >
                        <div></div>
                        <div class="txt-unrot">{{ $t('Webportal.DashboardBMW.ProcessExcellence') }}</div>
                        <div>
                          <performanceitem  :overallByWave="getOverallByWave"
                                            :kpi="getKpiGroupOverall"
                                            :isStandalone="true"
                                            :showInlineYtd="true" />
                        </div>
                      </div>
                      <div class="kpicontent kpi-pe">

                        <!-- Col1 -->
                        <div id="one">
                          <div class="kpi-co">
                            <div class="kpi-co-head">
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContact"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>

                            <!-- Online Enquiry -->
                            <div class="kpi-frame ti_border_dark" v-if="hasOnlineEnquiry()">

                              <div class="kpi-frame-head">{{ $t('Webportal.DashboardBMW.OnlineEnquiry') }}</div>
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactOnlineAutoResponse"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactOnlinePersonalResponse"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactOnlineLostLeads"
                                        :isDark="true"
                                        :hasDashBorder="true"
                                        :isHeader="false" />
                                        <!-- :isLostLead="true" -->
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactOnlineQualityStandards"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>

                            <!-- Telephone Enquiry -->
                            <div class="kpi-frame ti_border_dark" v-if="hasTelephoneEnquiry()">
                              <div class="kpi-frame-head">{{ $t('Webportal.DashboardBMW.TelephoneEnquiry') }}</div>
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactTelephoneReachability"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactTelephoneLostLeads"
                                        :hasDashBorder="true"
                                        :isDark="true"
                                        :isHeader="false" />
                                        <!-- :isLostLead="true" -->
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactTelephoneQualityStandards"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>
                          </div>
                        </div>

                        <!-- Col2 -->
                        <div id="two">
                          <div class="kpi-co">
                            <div class="kpi-co-head">
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiSalesConsultation"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>

                            <div class="kpi-frame-inv">
                              <div class="kpi-frame-head">&nbsp;</div>
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiSalesConsultationNeedAnalysis"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiSalesConsultationVehiclePresentation"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiSalesConsultationGeniusBenefit"
                                        :hasDashBorder="true"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>
                          </div>
                        </div>

                        <!-- Col3 -->
                        <div id="three">
                          <div class="kpi-co">
                            <div class="kpi-co-head">
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiTestDrive"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>

                            <div class="kpi-frame-inv">
                              <div class="kpi-frame-head">&nbsp;</div>
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiTestDriveOffer"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiTestDrivePerformance"
                                        :hasDashBorder="true"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiTestDriveRequirements"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>
                          </div>
                        </div>

                        <!-- Col4 -->
                        <div id="four">
                          <div class="kpi-co">
                            <div class="kpi-co-head">
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiOffer"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>

                            <div class="kpi-frame-inv">
                              <div class="kpi-frame-head">&nbsp;</div>
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiOfferAdditionalServices"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiOfferBmwProduct"
                                        :hasDashBorder="true"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiProductOfBrand"
                                        :hasDashBorder="true"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiOfferTradeInOffer"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiOfferMarketingOptIn"
                                        :hasDashBorder="true"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>
                          </div>
                        </div>

                        <!-- Col5 -->
                        <div id="five">
                          <div class="kpi-co">
                            <div class="kpi-co-head">
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactCare"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>

                            <div class="kpi-frame-inv">
                              <div class="kpi-frame-head">&nbsp;</div>
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactCareCourtesyMessage"
                                        :isDark="true"
                                        :isHeader="false" />

                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactCareMessageInformation"
                                        :hasDashBorder="true"
                                        :isDark="true"
                                        :isHeader="false" />

                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactCareAppointmentFU"
                                        :hasDashBorder="true"
                                        :isDark="true"
                                        :isHeader="false" />

                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactCareFollowUp"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>

                            <!-- <div class="kpi-col2-spacer"></div> -->

                            <div class="kpi-frame-inv" v-if="getKpiContactCareFollowUpOnline">
                              <div class="kpi-frame-head narrow_05">{{ $t('Webportal.DashboardBMW.OnlyOnlineWithoutPhysicalVisit') }}</div>
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactCareFollowUpOnline"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>

                            <div class="kpi-frame ti_border_dark" v-if="showCsqGermany">
                              <div class="kpi-frame-head">{{ $t('Webportal.DashboardBMW.CsqGermany') }}</div>
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactCareCsqAppointment"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactCareCsqPremium"
                                        :isDark="true"
                                        :isHeader="false" />
                              <kpiitem  :overallByWave="getOverallByWave"
                                        :kpi="getKpiContactCareCsqVisitorExperience"
                                        :isDark="true"
                                        :isHeader="false" />
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="am-two">
                      <div>
                        <div class="kpihead2 kpispec text-upper">
                          <div></div>
                          <div>{{ $t('Webportal.Dashboard.Recommendation') }}*</div>
                          <div></div>
                        </div>
                        <div class="kpicontent kpi-border kpi-centered">
                          <div class="spacer-1"></div>

                          <DoughnutChart  style="width: 8pc; height: 8pc; display: inline-block;"
                                          :chartData="getRecommendationChartData(getKpiRecommendation)" />
                            <p>{{ $t('Webportal.DashboardBMW.NetPromoterScore') }}</p>
                          <div class="kpi-frame-inv">
                            <kpiitem  :overallByWave="getOverallByWave"
                                      :kpi="getKpiRecommendation"
                                      :hasDashBorder="true"
                                      :isDark="true"
                                      :isHeader="false" />
                          </div>
                        </div>
                      </div>
                      <div class="spacer-1"></div>
                      <div>
                        <div class="kpihead2 kpispec text-lower">
                          <div></div>
                          <div>#{{ $t('Webportal.DashboardBMW.NumberOfShops') }}</div>
                          <div></div>
                        </div>
                        <div class="kpicontent kpi-border kpi-centered">
                          <ShopsOverall style="width: 100%; margin-top: 0.5rem; margin-bottom: 0.5rem;"
                                        :coloredHeader="false"
                                        :isBmwMoto="isBmwMoto"
                                        :overallValues="getOverallByWave"
                                        :isCompetitionOverall="false" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Specific Models -->
            <div class="card2 cardsection" v-if="hasEvResult() || hasGklResult()">
              <div class="card-body">
                <div class="wrapper wrap-sm">
                  <div class="txt-rot-sm" style="word-wrap: break-alld;">{{ $t('Webportal.DashboardBMW.SpecificModels') }}</div>
                  <div class="content">

                    <!-- xEV -->
                    <div class="kpi-frame-hor ti_border_dark" v-if="hasEvResult()">
                      <div class="kpi-hor-head-dbl">{{ $t('Webportal.DashboardBMW.xEV') }}</div>
                      <div class="kpi-hor-fill1">
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpixEvChargingInfrastructure"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpixEvNeedAnalysis"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpixEvProductPresentation"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpixEvHomeChargingProducts"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpixEvPublicChargingOffering"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                      </div>
                       <div class="kpi-hor-fill1">
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpixEvGovRegionalSupport"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpixEvTestDriveRequirements"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                        </div>
                        <div class="kpi-hor">
                        </div>
                        <div class="kpi-hor">
                        </div>
                      </div>
                    </div>

                    <!-- GKL -->
                    <div class="kpi-frame-hor ti_border_dark" v-if="hasGklResult()" style="margin-top:2px;">
                      <div class="kpi-hor-head">{{ $t('Webportal.DashboardBMW.GKL') }}</div>
                      <div class="kpi-hor-fill1">
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpiGklVehiclePresentation"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpiGklDeliveryOfTestVehicle"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpiGklTestDriveExperience"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpiGklNurtureProgram"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpiGklCustomerTreatment"
                                    :hasDashBorder="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 2019 v-if="has2019Result()" -->
            <div class="card2 cardsection" v-if="false" >
              <div class="card-body">
                <div class="wrapper wrap-2019">
                  <div class="txt-rot-2019">2019</div>
                  <div class="content">
                    <div class="kpi-frame-hor ti_border_dark">
                      <div class="kpi-hor-head-2019">
                        Customer Tr.
                      </div>
                      <div class="kpi-hor-fill1">
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :showNpsBar="true"
                                    :showPrewaves="false"
                                    :monochrome="true"
                                    :isDark="true"
                                    :isHeader="false"
                                    :kpi="getKpi2019VehiclePresentation" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpi2019DeliveryOfTestVehicle"
                                    :showNpsBar="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpi2019TestDriveExperience"
                                    :showNpsBar="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpi2019NurtureProgram"
                                    :showNpsBar="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                        <div class="kpi-hor">
                          <kpiitem  :overallByWave="getOverallByWave"
                                    :kpi="getKpi2019CustomerTreatment"
                                    :showNpsBar="true"
                                    :isDark="true"
                                    :isHeader="false" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Legende -->
        <div class="right">
          <div class="under">
            <!-- Performance Index -->
            <Legend2020 :isBMW2020="true"
                        :showTextItems="false" />
          </div>

          <!-- Lost Leads -->
          <!-- <div class="under">
            <Legend2020 titleTextKey="Webportal.DashboardBMW.KpiLostLeads"
                        :isLostLeads="true"
                        :isBMW2020="true"
                        :showTextItems="false" />
          </div> -->
          <div class="under">
            <NpsLegend />
          </div>

          <div class="under">
            <KpiWithPointsLegend />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import CustomKpiSorting from '@/mixins/CustomKpiSorting'
  import BrandMixin from '@/mixins/BrandMixin';
  import performanceitem from  './Year2020/PerformanceItem2020';
  import kpiitem from  './Year2020/KpiItem2020';
  import NpsLegend from  './Year2020/NpsLegend';
  import KpiWithPointsLegend from  './Year2020/KpiWithPointsLegend';
  import tableitem from  './TableItem';
  import Legend2020 from  './LegendControl';
  import ShopsOverall from './ShopsOverall';
  import DoughnutChart from '@/components/DoughnutChart';

  export default {
    name: 'DashboardPanel2020',

    mixins: [ CustomKpiSorting, BrandMixin ],

    props:{
      yearsList: { type: Array },
      yearsbywave: { type: Array },
      dashdata: { type: Object },
      optionsdata: { type: Object },
      isBmwMoto: { type: Boolean },
      isUsedBike: { type: Boolean },
      isBmwM: { type: Boolean },
      isBmwi: { type: Boolean },
      isUsedCar: { type: Boolean },
      isGebrauchtwagen: { type: Boolean },
      selectedBrand: { type: Array },
      selection: { type: Object },
    },

    components:{
      performanceitem,
      kpiitem,
      Legend2020,
      ShopsOverall,
      DoughnutChart,
      tableitem,
      NpsLegend,
      KpiWithPointsLegend
    },

    methods: {
      getKpiByString: function (name) {
        if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0) {
          let item = _.find(this.dashdata.KPI, (x) => x.KpiCode === name)
          if (item) return item
        }
      },
      getKpiGroupByString: function (code) {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return _.find(this.dashdata.OverallByWave, (x) => x.KpiCode === code)
      },
      hasEvResult: function() {
        let result = _.find(this.selectedBrand, function(x) { return _.startsWith(x, '1^xEV'); });
        result = result && !_.isEmpty(this.getKpixEvChargingInfrastructure);
        return result;
      },
      hasGklResult: function() {
        let result = _.includes(this.selectedBrand, '1^GKL');
        result = result && !_.isEmpty(this.getKpiGklVehiclePresentation);
        return result;
      },
      has2019Result: function() {
        let result = !_.isEmpty(this.getKpi2019VehiclePresentation)
                  || !_.isEmpty(this.getKpi2019DeliveryOfTestVehicle)
                  || !_.isEmpty(this.getKpi2019NurtureProgram)
                  || !_.isEmpty(this.getKpi2019CustomerTreatment)
                  || !_.isEmpty(this.getKpi2019TestDriveExperience);
        return result;
      },
      hasOnlineEnquiry: function() {
        let result = !_.isEmpty(this.getKpiContactOnlineAutoResponse)
                  || !_.isEmpty(this.getKpiContactOnlinePersonalResponse)
                  || !_.isEmpty(this.getKpiContactOnlineLostLeads)
                  || !_.isEmpty(this.getKpiContactOnlineQualityStandards);
        return result;
      },
      hasTelephoneEnquiry: function() {
        let result = !_.isEmpty(this.getKpiContactTelephoneReachability)
                  || !_.isEmpty(this.getKpiContactTelephoneLostLeads)
                  || !_.isEmpty(this.getKpiContactTelephoneQualityStandards);
        return result;
      },
      hasRecommendationChartData: function(kpi) {
        if (_.isEmpty(kpi)) {
          return false;
        }

        return !_.isEmpty(kpi.SurveyWave);
      },
      getRecommendationChartData: function(kpi) {
        if (_.isEmpty(kpi) || _.isEmpty(kpi.SurveyWave)) {
          return {};
        }

        let wave = _.last(kpi.SurveyWave);
        let dataPoints = [
          wave.ResultPromoters,
          100 - wave.ResultDetractors - wave.ResultPromoters,
          wave.ResultDetractors
        ];

        let result = {
          labels: [
            this.$t('Webportal.DashboardBMW.Promoters'),
            this.$t('Webportal.DashboardBMW.Passives'),
            this.$t('Webportal.DashboardBMW.Detractors')],
          datasets: [
            {
              backgroundColor: ['#A0D28F', '#FFFF79', '#FF2832'],
              data: dataPoints,
            }
          ]
        };
        return result;
      }
    },

    computed: {
      showCsqGermany: function() {
        let result = !_.isEmpty(this.getKpiContactCareCsqAppointment)
            || !_.isEmpty(this.getKpiContactCareCsqPremium)
            || !_.isEmpty(this.getKpiContactCareCsqVisitorExperience)
        return result;
      },
      getKpiGroupOverall: function() {
        return this.getKpiGroupByString('00. Overall')
      },

      getKpiGroupOverallOrdered: function() {
        let item = this.getKpiGroupByString('00. Overall');
        return this.getOrderedKpi(item);
      },

      getKpiGroupOverallKpiName: function() {
        var item = this.getKpiGroupOverall;
        if (item) {
          return item.KpiName
        }
      },

      getOverallByWave: function() {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return this.dashdata.OverallByWave[0]
        return undefined
      },

      isKpiGroupOverallVisible: function () {
        var _kpi = this.getKpiGroupOverall
        if (!_kpi || !_kpi.SurveyWave || _.size(_kpi.SurveyWave) === 0) {
          return false
        }
        var result =  _kpi.SurveyWave[0].ResultNSC
        return result  != undefined
      },

      hasDashdata: function () {
        return _.isEmpty(this.dashdata);
      },

      // 1
      getKpiContact: function() {
        return this.getKpiByString('01. Contact')
      },
      getKpiContactOnlineAutoResponse: function() {
        return this.getKpiByString('1A.6 Auto response (instantly)')
      },
      getKpiContactOnlinePersonalResponse: function() {
        return this.getKpiByString('1A.7 Personal response')
      },
      getKpiContactOnlineLostLeads: function() {
        return this.getKpiByString('1A.7 Personal response (onl. enq.) LL')
      },
      getKpiContactOnlineQualityStandards: function() {
        return this.getKpiByString('1A.9 Quality of response: standards (onl. enq.)')
      },
      getKpiContactTelephoneReachability: function() {
        return this.getKpiByString('1B.1 Reachability')
      },
      getKpiContactTelephoneLostLeads: function() {
        return this.getKpiByString('1B.1 Reachability LL')
      },
      getKpiContactTelephoneQualityStandards: function() {
        return this.getKpiByString('1B.2 Quality of response: standards (tel. enq.)')
      },

      // 2
      getKpiSalesConsultation: function() {
        return this.getKpiByString('02. Sales consultation')
      },
      getKpiSalesConsultationNeedAnalysis: function() {
        return this.getKpiByString('2.1 Need analysis')
      },
      getKpiSalesConsultationVehiclePresentation: function() {
        return this.getKpiByString('2.2 Product presentation')
      },
      getKpiSalesConsultationGeniusBenefit: function() {
        return this.getKpiByString('2.2.2 Genius Benefit')
      },

      // 3
      getKpiTestDrive: function() {
        return this.getKpiByString('03. Test Drive')
      },
      getKpiTestDriveOffer: function() {
        return this.getKpiByString('3.1 Test Drive Offer')
      },
      getKpiTestDrivePerformance: function() {
        return this.getKpiByString('3.1.1 Performance test drive')
      },
      getKpiTestDriveRequirements: function() {
        return this.getKpiByString('3.2 TD procedure requirements')
      },

      // 4
      getKpiOffer: function() {
        return this.getKpiByString('04. Offer')
      },
      getKpiOfferAdditionalServices: function() {
        return this.getKpiByString('4.1 Additional Services offered')
      },
      getKpiOfferBmwProduct: function() {
        return this.getKpiByString('4.1.1 BMW Product')
      },
      getKpiProductOfBrand: function() {
        return this.getKpiByString('4.1.1 Product of brand')
      },
      getKpiOfferTradeInOffer: function() {
        return this.getKpiByString('4.2 Trade-in Offer')
      },
      getKpiOfferMarketingOptIn: function() {
        return this.getKpiByString('4.3 Marketing opt-in')
      },

      // 5
      getKpiContactCare: function() {
        return this.getKpiByString('05. Contact Care')
      },
      getKpiContactCareCourtesyMessage: function() {
        return this.getKpiByString('5A.1 Courtesy text message (max. 4 hrs.)')
      },
      getKpiContactCareFollowUp: function() {
        return this.getKpiByString('5A.2 Follow-up on offer')
      },
      getKpiContactCareFollowUpOnline: function() {
        return this.getKpiByString('5B.1 Follow-up on offer (Onl.)')
      },

      getKpiContactCareMessageInformation: function() {
        return this.getKpiByString('5A.1.1 Message information')
      },
      getKpiContactCareAppointmentFU: function() {
        return this.getKpiByString('5. Appointment FU')
      },

      // CSQ: Germany
      getKpiContactCareCsqAppointment: function() {
        return this.getKpiByString('DE-1 Appointment for FU')
      },
      getKpiContactCareCsqPremium: function() {
        return this.getKpiByString('DE-2 Premium dealership')
      },
      getKpiContactCareCsqVisitorExperience: function() {
        return this.getKpiByString('DE-3 Visitor experience')
      },

      // 6
      getKpiRecommendation: function() {
        return this.getKpiByString('0.7 Recommend Brand (Cockpit)')
      },


      // xEV
      getKpixEvChargingInfrastructure: function() {
        return this.getKpiByString('B1 Charging infrastructure')
      },
      getKpixEvNeedAnalysis: function() {
        return this.getKpiByString('B2 xEV need analysis')
      },
      getKpixEvProductPresentation: function() {
        return this.getKpiByString('B3 xEV Product presentation')
      },
      getKpixEvHomeChargingProducts: function() {
        return this.getKpiByString('B4 Home Charging products')
      },
      getKpixEvPublicChargingOffering: function() {
        return this.getKpiByString('B5 Public Charging offering')
      },
      getKpixEvGovRegionalSupport: function() {
        return this.getKpiByString('B6 Gov.\/regional support')
      },
      getKpixEvTestDriveRequirements: function() {
        return this.getKpiByString('B7 TD further requirements')
      },

      // GKL
      getKpiGklVehiclePresentation: function() {
        return this.getKpiByString('A1 GKL+ vehicle presentation')
      },
      getKpiGklDeliveryOfTestVehicle: function() {
        return this.getKpiByString('A2 GKL+ Delivery of test drive vehicle')
      },
      getKpiGklTestDriveExperience: function() {
        return this.getKpiByString('A3 GKL+ Test drive experience')
      },
      getKpiGklNurtureProgram: function() {
        return this.getKpiByString('A4 GKL+ nurture program')
      },
      getKpiGklCustomerTreatment: function() {
        return this.getKpiByString('A5 GKL+ Customer treatment')
      },

      // 2019
      getKpi2019VehiclePresentation: function() {
        return this.getKpiByString('RS 20 (GKL+ vehicle presentation)')
      },
      getKpi2019DeliveryOfTestVehicle: function() {
        return this.getKpiByString('RS 21 (GKL+ Delivery of test drive vehicle)')
      },
      getKpi2019TestDriveExperience: function() {
        return this.getKpiByString('RS 22 (GKL+ Test drive experience)')
      },
      getKpi2019NurtureProgram: function() {
        return this.getKpiByString('RS 23 (GKL+ nurture program)')
      },
      getKpi2019CustomerTreatment: function() {
        return this.getKpiByString('RS 24 (GKL+ Customer treatment)')
      },
    }
  }
</script>


<style lang="scss" scoped>

.card {
  border: solid #000;
  border-width: 2px;
  border-radius: 0rem;
  margin-left: 0px;
}

.card-body {
  padding: 0pc;
  margin-left: 0pc;
}

.card-header {
  background: #0f0;
  height: 0px;
  margin: 0px;
  padding: 0px;
  border: solid #00F;
  border-width: 0px;
}

h3 {
  height: 36pt;
  line-height: 28pt;
  text-align: center;
  color: #111111;
  font-size: 16pt;
  font-stretch: extra-condensed;
}

</style>
